import React, { Component } from 'react';
import CarouselNavItem from './CarouselNavItem';

class CarouselNav extends Component {
  constructor() {
    super();
    this.state = {
      player: null
    }
  }



  renderNavItems(){
    var items = [];
    for (var i = 0; i < this.props.length; i++) {
      items.push(<CarouselNavItem current={this.props.current} index={i + 1} key={i} handleClick={this.props.handleNavigation.bind(this)}/>);
    }
    return items; 
  }

  render() {
    let navItems = this.renderNavItems()
    return (
      <div className="CarouselNav">
        {navItems}
      </div>
    );
  }
}

export default CarouselNav;


// WEBPACK FOOTER //
// ./src/Components/CarouselNav.js